import { v4 as uuidv4 } from 'uuid'

export const generateId = function () {
  return uuidv4()
}

export const generateNumberId = function () {
  return Math.floor(Math.random() * 1000000)
}
